// Окружение экранов из Claude Design: window.FFTheme, анимации ff-motion, внутренние ссылки без перезагрузки.
import type { Router } from 'vue-router';
import { installFit, installLinks, installMotion, installTheme } from '@platform/faculties/finfac/ui/runtime/client';

export function installDesignRuntime(router: Router): void {
  installTheme();
  installLinks(path => router.push(path));
}

export function afterMount(): void {
  installMotion();
  installFit();
}
